import {
  Subscription,
  TariffPlan,
  SubscriptionAnalytics,
  SubscriptionPlan,
  SubscriptionStatus,
  SubscriptionType,
} from './subscriptionTypes'

const generateId = (prefix: string, index: number) =>
  `${prefix}-${10000 + index}`

const randomDate = (start: Date, end: Date) => {
  return new Date(
    start.getTime() + Math.random() * (end.getTime() - start.getTime()),
  )
    .toISOString()
    .split('T')[0]
}

const firstNames = [
  'Анна',
  'Иван',
  'Мария',
  'Алексей',
  'Елена',
  'Дмитрий',
  'Ольга',
  'Сергей',
  'Наталья',
  'Павел',
  'John',
  'Emma',
  'Lucas',
  'Sophie',
]
const lastNames = [
  'Иванова',
  'Смирнов',
  'Петрова',
  'Соколов',
  'Волкова',
  'Морозов',
  'Новикова',
  'Волков',
  'Smith',
  'Johnson',
  'Williams',
  'Brown',
]

const generateName = () =>
  `${firstNames[Math.floor(Math.random() * firstNames.length)]} ${lastNames[Math.floor(Math.random() * lastNames.length)]}`

const plans: {
  code: SubscriptionPlan
  price: number
  type: SubscriptionType
}[] = [
  { code: 'basic', price: 490, type: 'astrologer' },
  { code: 'pro', price: 990, type: 'astrologer' },
  { code: 'premium', price: 2990, type: 'astrologer' },
  { code: 'reports_bundle', price: 390, type: 'user' },
  { code: 'courses_access', price: 1490, type: 'user' },
  { code: 'vip_consultations', price: 4990, type: 'user' },
]

export const mockSubscriptions: Subscription[] = Array.from({ length: 45 }).map(
  (_, i) => {
    const type: SubscriptionType = i % 3 === 0 ? 'user' : 'astrologer'
    const availablePlans = plans.filter((p) => p.type === type)
    const planObj =
      availablePlans[Math.floor(Math.random() * availablePlans.length)]

    let status: SubscriptionStatus = 'active'
    const rand = Math.random()
    if (rand > 0.9) status = 'payment_error'
    else if (rand > 0.8) status = 'cancelled'
    else if (rand > 0.7) status = 'paused'
    else if (rand > 0.6) status = 'expired'
    else if (rand > 0.5) status = 'trial'

    const startDate = randomDate(new Date(2023, 0, 1), new Date(2024, 2, 1))
    const endDate =
      status === 'expired' || status === 'cancelled'
        ? randomDate(new Date(startDate), new Date())
        : randomDate(new Date(), new Date(2025, 0, 1))

    const nextChargeDate = ['active', 'trial', 'payment_error'].includes(status)
      ? randomDate(new Date(), new Date(2024, 11, 31))
      : null

    const paymentsCount =
      Math.floor(Math.random() * 12) + (status === 'trial' ? 0 : 1)
    const ltv = paymentsCount * planObj.price

    const name = generateName()

    return {
      id: generateId('SUB', i),
      type,
      userId: `USR-${Math.floor(Math.random() * 9000) + 1000}`,
      userName: name,
      userEmail: `${name.split(' ')[0].toLowerCase()}.${name.split(' ')[1].toLowerCase()}@example.com`,
      userAvatar: name.substring(0, 2).toUpperCase(),
      plan: planObj.code,
      price: planObj.price,
      currency: '₽',
      billingPeriod: Math.random() > 0.8 ? 'yearly' : 'monthly',
      status,
      startDate,
      endDate,
      nextChargeDate,
      autoRenew: ['active', 'trial', 'payment_error'].includes(status),
      source: ['website', 'promo', 'admin', 'ios_app', 'android_app'][
        Math.floor(Math.random() * 5)
      ] as any,
      discountCode: Math.random() > 0.7 ? 'WELCOME20' : null,
      ltv,
      paymentsCount,
      country: ['Россия', 'Беларусь', 'Казахстан', 'Германия', 'США'][
        Math.floor(Math.random() * 5)
      ],

      history: [
        {
          id: `EVT-${Math.floor(Math.random() * 10000)}`,
          date: startDate,
          type: 'created',
          description: 'Подписка оформлена',
          actor: 'user',
        },
        ...(paymentsCount > 1
          ? [
              {
                id: `EVT-${Math.floor(Math.random() * 10000)}`,
                date: randomDate(new Date(startDate), new Date()),
                type: 'renewed' as const,
                description: 'Успешное продление',
                actor: 'system' as const,
              },
            ]
          : []),
        ...(status === 'payment_error'
          ? [
              {
                id: `EVT-${Math.floor(Math.random() * 10000)}`,
                date: new Date().toISOString().split('T')[0],
                type: 'payment_failed' as const,
                description: 'Ошибка списания средств',
                actor: 'system' as const,
              },
            ]
          : []),
      ],
      payments: Array.from({ length: paymentsCount }).map((_, j) => ({
        id: `PAY-${Math.floor(Math.random() * 100000)}`,
        date: randomDate(new Date(startDate), new Date()),
        amount: planObj.price,
        currency: '₽',
        status: 'success',
      })),
      activeErrors:
        status === 'payment_error'
          ? [
              {
                id: `ERR-${Math.floor(Math.random() * 10000)}`,
                date: new Date().toISOString().split('T')[0],
                amount: planObj.price,
                reason: 'insufficient_funds',
                attempts: Math.floor(Math.random() * 3) + 1,
                nextAttemptDate: new Date(Date.now() + 86400000)
                  .toISOString()
                  .split('T')[0],
                resolved: false,
              },
            ]
          : [],
      notes:
        Math.random() > 0.8
          ? 'VIP клиент, запросил скидку на следующий месяц'
          : '',
      activeServices:
        type === 'astrologer'
          ? ['Приоритет в каталоге', 'Расширенная аналитика']
          : ['Безлимитные натальные карты', 'Доступ к закрытым статьям'],
    }
  },
)

export const mockTariffPlans: TariffPlan[] = [
  {
    id: 'TPL-1',
    type: 'astrologer',
    name: 'Базовый Астролог',
    code: 'basic',
    description: 'Для начинающих специалистов',
    priceMonthly: 490,
    priceYearly: 4900,
    currency: '₽',
    isActive: true,
    features: [
      'Базовый профиль',
      'До 10 консультаций в месяц',
      'Стандартная поддержка',
    ],
    limits: {
      consultationsPerMonth: 10,
      profileViews: 'unlimited',
    },
    trialDays: 14,
  },
  {
    id: 'TPL-2',
    type: 'astrologer',
    name: 'Pro Астролог',
    code: 'pro',
    description: 'Для профессионалов',
    priceMonthly: 990,
    priceYearly: 9900,
    currency: '₽',
    isActive: true,
    features: [
      'Приоритет в поиске',
      'Безлимитные консультации',
      'Аналитика профиля',
      'Приоритетная поддержка',
    ],
    limits: {
      consultationsPerMonth: 'unlimited',
      profileViews: 'unlimited',
    },
    trialDays: 7,
  },
  {
    id: 'TPL-3',
    type: 'user',
    name: 'Пакет Отчетов',
    code: 'reports_bundle',
    description: 'Доступ ко всем автоматическим отчетам',
    priceMonthly: 390,
    priceYearly: 3900,
    currency: '₽',
    isActive: true,
    features: [
      'Натальная карта',
      'Соляр',
      'Синастрия',
      'Транзиты без ограничений',
    ],
    limits: {
      reportsPerMonth: 'unlimited',
    },
    trialDays: 3,
  },
]

export const mockAnalytics: SubscriptionAnalytics = {
  mrr: 248500,
  arpu: 1250,
  churnRate: 4.2,
  totalActive: 1850,
  totalTrial: 320,
  newThisMonth: 145,
  renewedThisMonth: 1680,
  revenueByPlan: {
    basic: 45000,
    pro: 125000,
    premium: 58500,
    reports_bundle: 20000,
  },
  retentionRate: 92.5,
}
